import axios from 'axios';

function getServiceUrl() {
  const env = process.env.VUE_APP_API_ENDPOINT;
  return env;
}

function callService(url, params, method) {
  return axios({
    method,
    url,
    data: params,
  });
}
const baseUrl = getServiceUrl();

const methodTypes = { post: 'post', get: 'get', put: 'put' };

export default {
  async GetTestTypes() {
    // eslint-disable-next-line prefer-template
    const response = callService(baseUrl + 'TestType', null, methodTypes.get);
    return response.data;
  },
  async RecaptchaValidate(action, token) {
    // eslint-disable-next-line prefer-template
    const response = await callService(
      // eslint-disable-next-line prefer-template
      baseUrl + 'ReCaptchaEnterprise',
      {
        Action: action,
        Token: token,
      },
      methodTypes.post,
    );

    return response.data;
  },
  async GetEligibility(firstName, lastName, dob, dlNumber, testType) {
    const response = await callService(
      // eslint-disable-next-line prefer-template
      baseUrl + 'Eligibility',
      {
        firstName,
        lastName,
        dob,
        dlNumber,
        testType,
      },
      methodTypes.post,
    );

    return response.data;
  },
  async Auth(firstName, lastName, dob, dlNumber, testType, reCAPTCHAtoken) {
    const response = await callService(
      // eslint-disable-next-line prefer-template
      baseUrl + 'auth',
      {
        firstName,
        lastName,
        dob,
        dlNumber,
        testType,
        reCAPTCHAtoken,
      },
      methodTypes.post,
    );

    return response.data;
  },
  async GetSiteData() {
    // eslint-disable-next-line prefer-template
    const response = await callService(baseUrl + 'SiteData', null, methodTypes.get);
    return response.data;
  },
  GetSiteDataUrl() {
    // eslint-disable-next-line prefer-template
    const url = baseUrl + 'SiteData';
    return url;
  },
  async GetBooking(firstName, lastName, dob, dlNumber) {
    const response = await callService(
      // eslint-disable-next-line prefer-template
      baseUrl + 'Booking',
      {
        firstName,
        lastName,
        dob,
        dlNumber,
      },
      methodTypes.post,
    );

    return response.data;
  },
  async GetAvailableLocation(typeId, zipCode, cityName, preferredDay, startDate) {
    const response = await callService(
      // eslint-disable-next-line prefer-template
      baseUrl + 'AvailableLocation',
      {
        typeId,
        zipCode,
        cityName,
        preferredDay,
        startDate,
      },
      methodTypes.post,
    );

    return response.data;
  },
  async GetLocation(locationId) {
    // eslint-disable-next-line prefer-template
    const response = await callService(baseUrl + 'Location/' + locationId, null, methodTypes.get);
    return response.data;
  },
  async GetLocationAvailability(locationId, typeId, sameDay, preferredDay, startDate) {
    const response = await callService(
      // eslint-disable-next-line prefer-template
      baseUrl + 'AvailableLocationDates',
      {
        locationId,
        typeId,
        sameDay,
        preferredDay,
        startDate,
      },
      methodTypes.post,
    );
    return response.data;
  },
  async HoldBookingSlot(slotId, dlNumber) {
    const response = await callService(
      // eslint-disable-next-line prefer-template
      baseUrl + 'HoldSlot',
      {
        slotId,
        dlNumber,
      },
      methodTypes.post,
    );
    return response.data;
  },
  async ReleaseBookingSlot(slotId, dlNumber) {
    const response = await callService(
      // eslint-disable-next-line prefer-template
      baseUrl + 'ReleaseSlot',
      {
        slotId,
        dlNumber,
      },
      methodTypes.post,
    );
    return response.data;
  },
  async NewBooking(
    dlNumber,
    firstName,
    lastName,
    dateOfBirth,
    email,
    cellPhone,
    serviceTypeId,
    bookingDateTime,
    bookingDuration,
    siteId,
    sendSms,
    responseId,
  ) {
    const response = await callService(
      // eslint-disable-next-line prefer-template
      baseUrl + 'NewBooking',
      {
        dlNumber,
        firstName,
        lastName,
        dateOfBirth,
        email,
        cellPhone,
        serviceTypeId,
        bookingDateTime,
        bookingDuration,
        siteId,
        sendSms,
        responseId,
      },
      methodTypes.post,
    );
    return response.data;
  },
  async RescheduleBooking(
    dlNumber,
    responseId,
    serviceTypeId,
    bookingDateTime,
    bookingDuration,
    firstName,
    lastName,
    dateOfBirth,
    email,
    homePhone,
    cellPhone,
    sendSms,
    siteId,
  ) {
    const response = await callService(
      // eslint-disable-next-line prefer-template
      baseUrl + 'RescheduleBooking',
      {
        dlNumber,
        responseId,
        serviceTypeId,
        bookingDateTime,
        bookingDuration,
        firstName,
        lastName,
        dateOfBirth,
        email,
        homePhone,
        cellPhone,
        sendSms,
        siteId,
      },
      methodTypes.post,
    );
    return response.data;
  },
  async CancelBooking(confirmationNumber, firstName, lastName, dateOfBirth, dlNumber) {
    const response = await callService(
      // eslint-disable-next-line prefer-template
      baseUrl + 'CancelBooking',
      {
        confirmationNumber,
        firstName,
        lastName,
        dateOfBirth,
        dlNumber,
      },
      methodTypes.post,
    );
    return response.data;
  },
};
